<template lang="pug">
div
  UiCardSection
    UiStack
      UiStackItem(fill)
        .ui-card-section-title {{ $t("admin_tools.tabs.machine_learning") }}
  UiCardSection
    RestTable(
      namespace="processed_companies"
      :headers="headers"
      ref="machineLearningTable"
      :fetch-handler="getData"
      :disable-pagination="true"
      embed
    )
      template(#cell:actions="{ item }")
        UiButton(
          size="sm"
          variant="smooth-primary"
          @click="startLearning(item)"
          icon="RefreshCw"
        ) {{ $t("admin_tools.relearn.start_learning") }}
</template>

<script>
import ApiMachineLearning from "@/api/machine_learning.js";

export default {
  data() {
    return {
      edited_items: [],
      headers: [
        {
          key: "id",
          label: "#",
        },
        {
          key: "company_name",
          label: "Company",
        },
        {
          key: "ml_method",
          label: "Algorythm",
        },
        {
          key: "accuracy",
          label: "Accuracy",
        },
        {
          key: "start_date",
          label: "Start Date",
        },
        {
          key: "end_date",
          label: "End Date",
        },
        {
          key: "actions",
          label: "",
          squeeze: true,
        },
      ],
    };
  },

  methods: {
    reloadList() {
      this.$refs.machineLearningTable.fetchData();
    },

    getData(_, config) {
      return ApiMachineLearning.fetchCompanies(config).then((resp) => {
        return {
          items: resp.data.companies,
          meta: resp.data.meta,
        };
      });
    },

    startLearning(company) {
      ApiMachineLearning.startLearning(company.id).then((resp) => {
        this.reloadList();
      });
    },
  },
};
</script>
